var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditLine = function SvgCreditLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M20 20h-9.6l-3.7-3.6c-.2-.2-.4-.3-.7-.3H4v2h1.6l3.7 3.6c.2.2.4.3.7.3h10c1.7 0 3-1.3 3-3s-1.3-3-3-3h-4c0-.8-.3-1.6-.9-2.1l-3.5-3.5c-.2-.2-.4-.3-.7-.3H4v2h6.5l3.2 3.2c.2.2.3.4.3.7s-.1.5-.3.7c-.4.4-1 .4-1.4 0l-1.5-1.5-1.4 1.4 1.5 1.5c.6.6 1.4.9 2.1.9s1.5-.3 2.1-.9l.1-.1H20c.6 0 1 .4 1 1s-.4 1-1 1M3 9.1H0v2h1v7H0v2h3zM19 9h-2c-.6 0-1-.4-1-1h-2c0 1.7 1.3 3 3 3v1h2v-1c1.7 0 3-1.3 3-3s-1.3-3-3-3h-2c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1h2c0-1.7-1.3-3-3-3V0h-2v1c-1.7 0-3 1.3-3 3s1.3 3 3 3h2c.6 0 1 .4 1 1s-.4 1-1 1"
  })));
};
export default SvgCreditLine;